import classes from "../classes";
import React from "react";

function isEmptyString(str) {
  return !str || typeof str !== "string" || str.trim().length === 0;
}

export function TooltipBlock({ children, onDark, speed, text, type }) {
  if (isEmptyString(text)) {
    return (
      <div>
        {children}
      </div>
    );
  }
  return (
    <div
      className={classes({
        "tooltip": true,
        "tooltip--is-fast": speed === "fast",
        "tooltip--is-last": type === "last",
        "tooltip--is-right": type === "right" || type === "last",
        "tooltip--white": onDark
      })}
      data-tooltip={text}>
      {children}
    </div>
  );
}

export function TooltipInline({ children, text, type }) {
  if (isEmptyString(text)) {
    return (
      <span>
        {children}
      </span>
    );
  }
  return (
    <span
      className={classes({
        "tooltip": true,
        "tooltip--is-last": type === "last",
        "tooltip--is-right": type === "right" || type === "last"
      })}
      data-tooltip={text}>
      {children}
    </span>
  );
}
